export var PRODUCTLINETYPE;
(function (PRODUCTLINETYPE) {
    PRODUCTLINETYPE["RULE_CENTER"] = "RULE_CENTER";
    PRODUCTLINETYPE["RESOURCE_SPACE_CONTENT"] = "RESOURCE_SPACE_CONTENT";
})(PRODUCTLINETYPE || (PRODUCTLINETYPE = {}));
